import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SubjectFields from './SubjectFields'

export const SubjectCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <SubjectFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default SubjectCreate
